import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  Box,
  Typography,
  IconButton,
  Checkbox,
  Chip,
  Stack,
  Grid,
  Row,
} from "@mui/material";

const TableData = ({ title, headers = [], datas = [], isTable = true }) => {
  return (
    <Grid container spacing={2} style={{ marginBottom: "16px" }}>
      <Grid
        item
        xs={12}
        sm={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          component="div"
          style={{ fontSize: "16px", fontWeight: "bolder" }}
        >
          {title}
        </Typography>
      </Grid>
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          background: "transparent",
          borderRadius: "10px",
        }}
      >
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table>
            <TableHead
              style={{
                background: "linear-gradient(90deg, #00BB9F 0%, #6CD8BF 100%)",
              }}
            >
              <TableRow>
                {headers.map((column, key) => {
                  const cellStyles = {
                    width:
                      key === 0 && isTable
                        ? "1vw"
                        : `${100 / headers.length}vw`,
                    color: "white",
                  };
                  return (
                    <TableCell key={key} style={cellStyles}>
                      {column.label}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody style={{ backgroundColor: "white" }}>
              {datas.map((row, key) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={key}>
                    {!isTable ? (
                      <TableCell>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            {row.label}
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            {key == 0 ? (
                              <img
                                src={row.data}
                                alt={row.data}
                                style={{ width: "75px" }}
                              />
                            ) : (
                              row.data
                            )}
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : (
                      <>
                        <TableCell style={{ fontSize: "12px" }}>
                          {key + 1}
                        </TableCell>
                        {Object.values(row).map((cell, i) => (
                          <TableCell key={i} style={{ fontSize: "12px" }}>
                            {cell}
                          </TableCell>
                        ))}
                      </>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
};

export default TableData;
